import React from "react";
import EmployeeTurnoverCalculator from "./employeeTurnoverCalculator";
import styles from "@buddieshr/styles/components/turnover/turnoverCostCalculatorPanel.module.scss";

const TurnoverCostCalculatorPanel = () => (
  <div className={`${styles.panel} ${styles.panelCalculator}`}>
    <div className={styles.flexWrapper}>
      <div className={styles.left}>
        <h2 className={styles.title}>
          How to calculate the cost of employee turnover
        </h2>
        <div>
          The calculation takes into account direct and indirect impacts:
          <ul className={styles.list}>
            <li> the loss of knowledge</li>
            <li>
              the productivity lost from other employees filling in for the
              vacant position
            </li>
            <li>the cost to hire replacement</li>
            <li>the new hire training cost</li>
            <li>the time to return to previous productivity level</li>
          </ul>
        </div>
        <div style={{ fontSize: "14px", marginTop: "24px", color: "#94a8ce" }}>
          The full details of the calculation is available at the last step.
        </div>
      </div>
      <div className={styles.right}>
        <EmployeeTurnoverCalculator />
      </div>
    </div>
  </div>
);

export default TurnoverCostCalculatorPanel;
